export default function WeaponEdit() {
  return <div>We are now editing the weapon</div>
}
